module.exports = __webpack_public_path__ + "static/media/what-are-ready-to-do.e41d69a8.png";